import { createSlice } from '@reduxjs/toolkit'
import { createPrimaryWorkFlow } from 'api/formDisplay'

const initialState = {
  activeStepOrder: 1,
  configurationId: '',
  primaryWorkflowId: '',
  showAccountList: false,
  switchProfile: false,
  dynamicConfigId: '',
  userInitatedRequired: null,
  isAPILoadingForLinkExpiryValidation: false,
}

export const conditionalRendering = createSlice({
  name: 'conditionalRendering',
  initialState,
  reducers: {
    incrementActiveStepOrder: (state, action) => {
      state.activeStepOrder = action.payload
    },
    decrementActiveStepOrder: (state) => {
      state.activeStepOrder -= 1
    },
    setActiveStepOrder: (state, action) => {
      state.activeStepOrder = action.payload
    },
    setConfigurationId: (state, action) => {
      state.configurationId = action.payload
    },
    setShowAccountList: (state, action) => {
      state.showAccountList = action.payload
    },
    setPrimaryWorkflowId: (state, action) => {
      state.primaryWorkflowId = action.payload
    },
    setSwitchProfile: (state, action) => {
      state.switchProfile = action.payload
    },
    setDynamicConfigId: (state, action) => {
      state.dynamicConfigId = action.payload
    },
    setUserInitiatedRequired: (state, action) => {
      state.userInitatedRequired = action.payload
    },
    setIsAPILoadingForLinkExpiryValidation: (state, action) => {
      state.isAPILoadingForLinkExpiryValidation = action.payload
    }
  },

})

// Action creators are generated for each case reducer function
export const {
  incrementActiveStepOrder,
  decrementActiveStepOrder,
  setActiveStepOrder,
  setConfigurationId,
  setShowAccountList,
  setPrimaryWorkflowId,
  setSwitchProfile,
  setDynamicConfigId,
  setUserInitiatedRequired,
  setIsAPILoadingForLinkExpiryValidation
} = conditionalRendering.actions

export default conditionalRendering.reducer